import { ArrowDown, MapPin } from 'lucide-react';
import { OUR_STORY } from '@/data/about';
import { SlashMark } from '../AmdenMark';
import { Reveal } from '../Reveal';
import { scrollToId } from '@/lib/scroll';

export const OurStory = () => (
  <section aria-labelledby="story-heading" data-testid="our-story-section" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-6">
          <p className="flex items-center gap-3">
            <span className="font-mono text-xs font-medium tracking-widest text-gold-700">01</span>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold-700">{OUR_STORY.eyebrow}</span>
          </p>
          <h2 id="story-heading" className="mt-4 max-w-lg text-balance text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
            {OUR_STORY.heading}
          </h2>
          <div className="mt-6 max-w-xl space-y-5 text-base leading-relaxed text-slate-600">
            {OUR_STORY.paragraphs.map((p) => (
              <p key={p.slice(0, 24)}>{p}</p>
            ))}
          </div>
          <p className="mt-8 max-w-xl border-l-2 border-gold-600 pl-5 font-serif text-xl font-medium italic leading-relaxed text-navy-800" data-testid="story-highlight">
            {OUR_STORY.highlight}
          </p>
          <button
            type="button"
            onClick={() => scrollToId('#founders')}
            data-testid="story-meet-founders-btn"
            className="group mt-9 inline-flex items-center gap-2 text-sm font-bold text-navy-900 transition-colors hover:text-gold-700"
          >
            Meet the people behind Amden
            <ArrowDown className="h-4 w-4 transition-transform duration-200 group-hover:translate-y-0.5" aria-hidden="true" />
          </button>
        </Reveal>

        <Reveal delay={0.12} className="lg:col-span-6">
          <div className="relative">
            <SlashMark
              className="pointer-events-none absolute -left-10 -top-10 h-40 w-40 opacity-[0.06]"
              bar="#0B1729"
              dot="#FFB800"
            />
            <div className="relative overflow-hidden rounded-xl border border-slate-200 shadow-card">
              <img
                src={OUR_STORY.image.src}
                alt={OUR_STORY.image.alt}
                width={OUR_STORY.image.width}
                height={OUR_STORY.image.height}
                loading="lazy"
                data-testid="story-image"
                className="aspect-[4/3] w-full object-cover"
              />
            </div>
            <div
              data-testid="story-location-chip"
              className="absolute -bottom-5 right-4 flex items-center gap-2.5 rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-card sm:right-8"
            >
              <MapPin className="h-4 w-4 shrink-0 text-gold-700" aria-hidden="true" />
              <span className="text-sm font-bold text-navy-900">{OUR_STORY.locationChip}</span>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
